
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Button from '../../Subcomponents/Button';
import ProgressCard from '../../Subcomponents/ProgressCard';
import cssClasses from './CreateLaunch.module.css'
import createLaunchImg from '../../Assets/Images/Common/createLaunch.svg'
import TabsMenu from '../../Subcomponents/TabsMenu';
import { isEqual, differenceWith, cloneDeep, sortBy, groupBy, uniq, sortedUniq, uniqBy } from 'lodash'
//* import mui
import { Box, Checkbox } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import CustomInput from '../../Subcomponents/CustomInput';
import SelectProject from '../../Components/SelectProject/SelectProject';
import { getAllProjects } from '../../Services/Project';
import Radio from "@mui/material/Radio";
import { errorTost, successTost } from '../../Services/Toast';
import { addLaunch, deleteCpRelations, deletePaymentRelations, deletePriceListRelations, deleteSalesRelations, editLaunch, getAllCpByLaunch, getAllSalesByLaunch, getLaunchById, getLaunchByTitle, insertIntoCpRelations, insertIntoPaymentRelations, insertIntoPriceListRelations, insertIntoSalesRelations, updateLaunch } from '../../Services/Launch';
import ConfirmationAlert from '../../Subcomponents/ConfirmationAlert';
import SelectSalesCp from '../../Components/SelectSalesCp/SelectSalesCp';
import { getAllCpForLaunch } from '../../Services/ChannelPartner';
import { getAllSales } from '../../Services/Sales';
import SelectInventory from '../../Components/SelectInventory/SelectInventory';
import { deleteInventoryMerge, deleteInventoryRelations, deleteInventoryRelationsOfLaunch, getAllInventory, getInventoryMerge, getInventoryStatus, getLaunchInventory, getProjectInventory, insertIntoInventoryMerge, insertIntoInventoryRelations, updateInventory, updateInventoryRelations } from '../../Services/Inventory';
import { useDispatch } from 'react-redux';
import action from "../../Redux Store/actions";
import { getAllPlansByLaunch, getAllPlansByProject, getAllPricingByLaunch, getAllPricingByProject } from '../../Services/PaymentPlans';
import { dismissLoader, presentLoader } from '../../Services/loader';
import PreselectConfig from '../../Components/PreselectConfig/PreselectConfig';
import { supabase } from '../../supabaseClient';
import CustomToggle from '../../Subcomponents/Toggle/CustomToggle';
import { MuiColorInput } from 'mui-color-input';
import { makeStyles } from "@mui/styles";
import OnlineBookingConfig from '../../Components/OnlineBookingConfig/OnlineBookingConfig';

export default function CreateLaunch() {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useParams()
    const navigate = useNavigate()
    const useStyles = makeStyles((theme) => ({
        Tooltip: {
          "&.MuiTooltip-tooltip": {
            fontSize: "1.2rem",
          },
        },
      }));

      const classes = useStyles();
    const eventId = params.eventId
    const launchId = searchParams.get('launch')
    const submenu = searchParams.get('submenu')
    const dispatch = useDispatch();
    const [allProjects, SetAllProjects] = useState([])
    const [allSales, setAllSales] = useState([])
    const [allChildSales, setAllChildSales] = useState([])
    const [allCp, setAllCp] = useState([])
    const [allChildCp, setAllChildCp] = useState([])
    const [allPlans, setAllPlans] = useState([])
    const [allChildPlans, setAllChildPlans] = useState([])

    const [allPriceList, setAllPriceList] = useState([])
    const [allChildPriceList, setAllChildPriceList] = useState([])
    const [allInventory, setAllInventory] = useState([])
    const [allChildInventory, setAllChildInventory] = useState([])
    const [searchProject, setSearchProject] = useState('')
    const [searchSales, setSearchSales] = useState('')
    const [searchCp, setSearchCp] = useState('')
    const [searchPlan, setSearchPlan] = useState('')
    const [searchPriceList, setSearchPriceList] = useState('')
    const [launchTitleHelperText, setLaunchTitleHelperText] = useState('')
    const [projectMode, setProjectMode] = useState('')
    const [openAlert, setOpenAlert] = useState(false)
    const [clickedIndex, setClickedIndex] = useState(0)
    const [floorsSelected, setFloorsSelected] = useState([])
    const [unitsToMerge, setUnitsToMerge] = useState([])
    const [showMerge, setShowMerge] = useState(false)
    const [useCsv, setUseCsv] = useState(false)
    const [allUnitsToMerge, setAllUnitsToMerge] = useState([])
    const [totalFloorsSelected, setTotalFloorsSelected] = useState(0)
    const [totalUnitsSelected, setTotalUnitsSelected] = useState(0)
    const [launchTitle, setLaunchTitle] = useState('');
    const [LaunchInventoryData , setLaunchInventoryData] = useState([]);
    const [projectId, setProjectId] = useState('')
    const [launch, setLaunch] = useState({})
    const [launchData, setLaunchData] = useState(null)
    const [eventTokens, setEventTokens] = useState([]);
    const [childLaunch, setChildLaunch] = useState({})
    const [createLaunch, setCreateLaunch] = useState(
        {
            title: "Create a launch",
            totalProgress: 6,
            timeline: [
                { text: "Add Launch Title", value: "Add Launch Title", isSelected: true },
                { text: "Select Project", value: "Select Project", isSelected: false },
                { text: "Select Sales", value: "Select Sales", isSelected: false },
                { text: "Select Cp", value: "Select Cp", isSelected: false },
                { text: "Select Inventory", value: "Select Inventory", isSelected: false },
                { text: "Select PriceList", value: "Select PriceList", isSelected: false },
                { text: "Select Payment Plans", value: "Select Payment Plans", isSelected: false },
                { text: "Preview Inventory", value: "Preview Inventory", isSelected: false },
            ],
            image: createLaunchImg
        })

    const salesGridColumns = [
        {
            field: "name",
            headerName: "Name",
            width: 400,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div>
                            <Checkbox checked={params.row?.isSelected} onChange={(e) => { setAllChildSales((pre) => { pre[pre.findIndex((e) => e.id === params.row.id)].isSelected = !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected; return [...pre] }) }} />
                        </div>
                        <div>
                            <p>{params.row.name}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "email",
            headerName: "Mail Id",
            width: 250
        },
        {
            field: "contactNumber",
            headerName: "Contact Number",
            width: 250
        },
    ]

    const planGridColumns = [
        {
            field: "key",
            headerName: "Key",
            width: 350,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div>
                            <Checkbox checked={params.row?.isSelected} onChange={(e) => { setAllChildPlans((pre) => { pre[pre.findIndex((e) => e.id === params.row.id)].isSelected = !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected; return [...pre] }) }} />
                        </div>
                        <div>
                            <p>{params.row.key}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "title",
            headerName: "Title",
            width: 250
        },
        {
            field: "wingName",
            headerName: "Wing",
            width: 450
        },
        {
            field: "unitType",
            headerName: "Unit Type",
            width: 150
        },
        // {
        //     field: "discount",
        //     headerName: "Discount",
        //     width: 150
        // },
    ]

    const PriceGridColumns = [
        {
            field: "title",
            headerName: "Title",
            width: 250,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div>
                            <Checkbox checked={params.row?.isSelected} onChange={(e) => { setAllChildPriceList((pre) => { pre[pre.findIndex((e) => e.id === params.row.id)].isSelected = !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected; return [...pre] }) }} />
                        </div>
                        <div>
                            <p>{params.row.title}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "wingName",
            headerName: "Wing",
            width: 250
        },
        {
            field: "startDateTime",
            headerName: "Start Date Time",
            width: 250
        },
        {
            field: "endDateTime",
            headerName: "End Date Time",
            width: 250
        },
    ]

    const cpGridColumns = [
        {
            field: "billingName",
            headerName: "Cp Name",
            width: 400,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div>
                            <Checkbox checked={params.row?.isSelected} onChange={(e) => { setAllChildCp((pre) => { pre[pre.findIndex((e) => e.id === params.row.id)].isSelected = !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected; return [...pre] }) }} />
                        </div>
                        <div>
                            <p>{params.row.billingName}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "contactPersonName",
            headerName: "Contact Person Name",
            width: 250
        },
        {
            field: "email",
            headerName: "Mail Id",
            width: 250
        },
        {
            field: "contactNumber",
            headerName: "Contact Number",
            width: 250
        },
    ]

    const projectGridColums = [
        {
            field: "projectName",
            headerName: "Project Title",
            width: 400,
            renderCell: (params) => {
                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem'
                    }}>
                        <div>
                            <Radio checked={params.row?.eventId} onChange={(e) => { projectSelected(e, params) }} />
                        </div>
                        <div>
                            <p>{params.row.projectName}</p>
                        </div>
                    </div>
                )
            }
        },
        {
            field: "addressLine1",
            headerName: "Location",
            width: 250
        },
    ]

    useEffect(() => {

        const getEventsTokenList = () => {
            supabase.from('EventTokens').select('*,tokenId(*)').eq('eventId', params.eventId).eq('tokenId.isPreselect', true).then((resp) => {
                if (resp.data.length > 0) {
                    console.log(resp.data.filter((e) => { return e.tokenId }))
                    setEventTokens(resp.data.filter((e) => { return e.tokenId }))
                }
            }).catch((err) => {
                console.log(err)
            })
        }
        getEventsTokenList()
    },[])

    useEffect(() => {
        dispatch(action.activeMenu("ConfigureEvent"));
        if (!launchId) {
            setProjectMode('add')
            setLaunch({
                title: '',
                eventId: params.eventId,
                projectId: '',
                // basePrice: null,
                // pricing: { plc: [], floorRise: [], parking: [{ value: null, type: '', name: '' }] },
                completedTabs: []
            })
            // setChildLaunch({ pricing: { plc: [], floorRise: [], parking: [{ value: null, type: '', name: '' }] }, basePrice: null })
            setLaunchTitle('')
            setProjectId('')
        } else {
            setProjectMode('edit')
            getLaunchById(launchId).then((resp) => {

                setLaunch({
                    launchId: resp.data[0].launchId,
                    title: resp.data[0].title,
                    eventId: resp.data[0].eventId,
                    projectId: resp.data[0].projectId.projectId,
                    // basePrice: resp.data[0].basePrice,
                    // pricing: resp.data[0].pricing,
                    completedTabs: resp.data[0].completedTabs
                })
                setLaunchData({
                    preselectConfirmationConfig: resp.data[0]?.preselectConfirmationConfig,
                    showPreselectPrices:resp.data[0]?.showPreselectPrices
                })
                // let obj = cloneDeep(resp)
                // setChildLaunch({ pricing: obj.data[0].pricing, basePrice: obj.data[0].basePrice })
                console.log(resp.data[0].projectId)
                setLaunchTitle(resp.data[0].title)
                setProjectId(resp.data[0].projectId.projectId)
                setUseCsv(resp.data[0].projectId.useCsvPrice)
            })
        }
    }, [])

    useEffect(() => {
        tabChanged('', submenu)
        console.log(launchId)
    }, [submenu, launchId])

    useEffect(() => {
        setCreateLaunch((pre) => {
            pre.timeline.forEach((ele) => {
                if (launch.completedTabs?.includes(ele.text)) {
                    ele.isCompleted = true
                }
            })
            return { ...pre }
        })
    }, [launch])

    useEffect(() => {
        if (createLaunch.timeline[1].isSelected === true) {
            if (allProjects.length === 0) {
                presentLoader()
                getAllProjects().then((resp) => {
                    resp.data.forEach((ele, index) => { ele.show = true; ele.id = ele.projectId; ele.index = index; if (projectId && ele.projectId === projectId) { ele.eventId = eventId } })
                    SetAllProjects(resp.data)
                    dismissLoader()
                }).catch((err) => {
                    dismissLoader()
                })
            } else {
                if (searchProject === '') {
                    let arr = cloneDeep(allProjects)
                    arr.forEach((e, i) => {
                        e.show = true
                        if (i === arr.length - 1) {
                            SetAllProjects([...arr])
                        }
                    })
                } else {
                    allProjects.forEach((ele) => {
                        if (!ele.projectName.toUpperCase().includes(searchProject.toUpperCase())) {
                            SetAllProjects((pre) => { pre[pre.findIndex((e) => e.projectName === ele.projectName)].show = false; return [...pre] })
                        } else {
                            SetAllProjects((pre) => { pre[pre.findIndex((e) => e.projectName === ele.projectName)].show = true; return [...pre] })
                        }
                    })
                }
            }
        }
    }, [searchProject, createLaunch])

    useEffect(() => {
        if (createLaunch.timeline[6].isSelected === true) {
            if (allPlans.length === 0) {
                presentLoader()
                getAllPlansByProject(launch.projectId).then((resp) => {
                    resp.data.forEach((ele, index) => { ele.id = ele.paymentPlanId; ele.show = true; ele.index = index; ele.isSelected = false; ele.unitType = ele.inventoryTypeId.type; ele.wingName = ele.wingId.wingName; ele.discount = ele.operation === "Discount" ? '-  ' + (ele.type === 'Fixed' ? '₹ ' + numberWithCommas(ele.discount) : ele.discount + '%') : '+  ' + (ele.type === 'Fixed' ? '₹ ' + numberWithCommas(ele.discount) : ele.discount + '%') })
                    console.log(resp.data)
                    getAllPlansByLaunch(launch.launchId).then((res) => {
                        if (res.data.length > 0) {
                            res.data.forEach((ele, index) => {
                                resp.data[resp.data.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].isSelected = true
                                resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }])
                                let newarr = cloneDeep(resp.data)
                                if (index === res.data.length - 1) {
                                    // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                                    setAllChildPlans([...resp.data])
                                    setAllPlans([...newarr])
                                    dismissLoader()
                                }
                            })
                        } else {
                            let newarr = cloneDeep(resp.data)
                            setAllChildPlans([...resp.data])
                            setAllPlans([...newarr])
                            dismissLoader()
                        }
                    }).catch((err) => {
                        let newarr = cloneDeep(resp.data); setAllChildPlans([...resp.data]); setAllPlans([...newarr])
                        dismissLoader()
                    })
                }).catch((err) => {
                    dismissLoader()
                })
            } else {
                if (searchPlan === '') {
                    allChildPlans.forEach((e, index) => { setAllChildPlans((pre) => { pre[index].show = true; return [...pre] }) })
                    allPlans.forEach((e, index) => { setAllPlans((pre) => { pre[index].show = true; return [...pre] }) })
                } else {
                    allPlans.forEach((ele) => {
                        if (!ele.key.toUpperCase().includes(searchPlan.toUpperCase())) {
                            setAllChildPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].show = false; return [...pre] })
                            setAllPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].show = false; return [...pre] })
                        } else {
                            setAllChildPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].show = true; return [...pre] })
                            setAllPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].show = true; return [...pre] })
                        }
                    })
                    setAllChildPlans(sortBy(allChildPlans, [function (o) { return !o.isSelected }]))
                }
            }
        }
    }, [searchPlan, createLaunch])

    useEffect(() => {
        if (createLaunch.timeline[5].isSelected === true) {
            if (allPriceList.length === 0) {
                presentLoader()
                getAllPricingByProject(launch.projectId).then((resp) => {
                    console.log("resp", resp.data)
                    resp.data.forEach((ele, index) => {
                        ele.id = ele.projectPricingId; ele.show = true; ele.index = index; ele.isSelected = false; ele.wingName = ele.wingId.wingName;
                        ele.startDateTime = ele.startDateTime ? new Date(ele.startDateTime).toDateString() + "," + new Date(ele.startDateTime).toLocaleTimeString([], {
                            hour: "2-digit", minute: "2-digit",
                        }) : 'Default';
                        ele.endDateTime = ele.endDateTime ? new Date(ele.endDateTime).toDateString() + "," + new Date(ele.endDateTime).toLocaleTimeString([], {
                            hour: "2-digit", minute: "2-digit",
                        }) : 'Default'
                    })
                    console.log(resp.data)
                    getAllPricingByLaunch(launch.launchId).then((res) => {
                        if (res.data.length > 0) {
                            res.data.forEach((ele, index) => {
                                resp.data[resp.data.findIndex((e) => e.projectPricingId === ele.projectPricingId)].isSelected = true
                                resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }])
                                let newarr = cloneDeep(resp.data)
                                if (index === res.data.length - 1) {
                                    // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                                    setAllChildPriceList([...resp.data])
                                    setAllPriceList([...newarr])
                                    dismissLoader()
                                }
                            })
                        } else {
                            let newarr = cloneDeep(resp.data)
                            setAllChildPriceList([...resp.data])
                            setAllPriceList([...newarr])
                            dismissLoader()
                        }
                    }).catch((err) => {
                        let newarr = cloneDeep(resp.data); setAllChildPriceList([...resp.data]); setAllPriceList([...newarr])
                        dismissLoader()
                    })
                }).catch((err) => {
                    dismissLoader()
                })
            } else {
                if (searchPriceList === '') {
                    allChildPlans.forEach((e, index) => { setAllChildPriceList((pre) => { pre[index].show = true; return [...pre] }) })
                    allPriceList.forEach((e, index) => { setAllPriceList((pre) => { pre[index].show = true; return [...pre] }) })
                } else {
                    allPriceList.forEach((ele) => {
                        if (!ele.title.toUpperCase().includes(searchPriceList.toUpperCase())) {
                            setAllChildPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)].show = false; return [...pre] })
                            setAllPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)].show = false; return [...pre] })
                        } else {
                            setAllChildPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)].show = true; return [...pre] })
                            setAllPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)].show = true; return [...pre] })
                        }
                    })
                    setAllChildPriceList(sortBy(allChildPriceList, [function (o) { return !o.isSelected }]))
                }
            }
        }
    }, [searchPriceList, createLaunch])

    useEffect(() => {
        if (createLaunch.timeline[3].isSelected === true) {
            if (allCp.length === 0) {
                presentLoader()
                getAllCpForLaunch("").then((resp) => {
                    resp.data.forEach((ele, index) => { const contact = ele.CpContactPerson?.[0] ?? {}; ele.id = ele.cpId; ele.show = true; ele.index = index; ele.contactPersonName = contact.name ?? ''; ele.email = contact.email ?? ''; ele.contactNumber = contact.contactNumber ?? ''; ele.isSelected = false })
                    getAllCpByLaunch(launch.launchId).then((res) => {
                        if (res.data.length > 0) {
                            res.data.forEach((ele, index) => {
                                resp.data[resp.data.findIndex((e) => e.cpId === ele.cpId)].isSelected = true
                                resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }])
                                let newarr = cloneDeep(resp.data)
                                if (index === res.data.length - 1) {
                                    // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                                    setAllChildCp([...resp.data])
                                    setAllCp([...newarr])
                                    dismissLoader()
                                }
                            })
                        } else {
                            let newarr = cloneDeep(resp.data)
                            setAllChildCp([...resp.data])
                            setAllCp([...newarr])
                            dismissLoader()
                        }
                    }).catch((err) => {
                        let newarr = cloneDeep(resp.data); setAllChildCp([...resp.data]); setAllCp([...newarr])
                        dismissLoader()
                    })
                }).catch((err) => {
                    dismissLoader()
                })
            } else {
                if (searchCp === '') {
                    allChildCp.forEach((e, index) => { setAllChildCp((pre) => { pre[index].show = true; return [...pre] }) })
                    allCp.forEach((e, index) => { setAllCp((pre) => { pre[index].show = true; return [...pre] }) })
                } else {
                    allCp.forEach((ele) => {
                        if (!ele.billingName.includes(searchCp.toUpperCase())) {
                            setAllChildCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = false; return [...pre] })
                            setAllCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = false; return [...pre] })
                        } else {
                            setAllChildCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = true; return [...pre] })
                            setAllCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = true; return [...pre] })
                        }
                    })
                    setAllChildCp(sortBy(allChildCp, [function (o) { return !o.isSelected }]))
                }
            }
        }
    }, [searchCp, createLaunch])

    useEffect(() => {
        if (createLaunch.timeline[2].isSelected === true) {
            if (allSales.length === 0) {
                presentLoader()
                getAllSales().then((resp) => {
                    resp.data.forEach((ele, index) => { ele.id = ele.userId; ele.show = true; ele.index = index; ele.isSelected = false })
                    getAllSalesByLaunch(launch.launchId).then((res) => {
                        if (res.data.length > 0) {
                            res.data.forEach((ele, index) => {
                                resp.data[resp.data.findIndex((e) => e.userId === ele.userId)].isSelected = true
                                resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }])
                                let newarr = cloneDeep(resp.data)
                                if (index === res.data.length - 1) {
                                    // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                                    setAllChildSales([...resp.data])
                                    setAllSales([...newarr])
                                    dismissLoader()
                                }
                            })
                        } else {
                            let newarr = cloneDeep(resp.data)
                            setAllChildSales([...resp.data])
                            setAllSales([...newarr])
                            dismissLoader()
                        }
                    }).catch((err) => {
                        let newarr = cloneDeep(resp.data); setAllChildSales([...resp.data]); setAllSales([...newarr])
                        dismissLoader()
                    })
                }).catch((err) => {
                    dismissLoader()
                })
            } else {
                if (searchSales === '') {
                    allChildSales.forEach((e, index) => { setAllChildSales((pre) => { pre[index].show = true; return [...pre] }) })
                    allSales.forEach((e, index) => { setAllSales((pre) => { pre[index].show = true; return [...pre] }) })
                } else {
                    allSales.forEach((ele) => {
                        if (!ele.name.toUpperCase().includes(searchSales.toUpperCase())) {
                            setAllChildSales((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = false; return [...pre] })
                            setAllSales((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = false; return [...pre] })
                        } else {
                            setAllChildSales((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = true; return [...pre] })
                            setAllSales((pre) => { pre[pre.findIndex((e) => e.name === ele.name)].show = true; return [...pre] })
                        }
                    })
                    setAllChildSales(sortBy(allChildSales, [function (o) { return !o.isSelected }]))
                }
            }
        }
    }, [searchSales, createLaunch])

    useEffect(() => {
        if (createLaunch.timeline[4].isSelected === true || createLaunch.timeline[6].isSelected === true || createLaunch.timeline[5].isSelected === true) {
            if (allInventory.length === 0) {
                dismissLoader()
                getProjectInventory(launch.projectId).then((resp) => {
                    // getAllInventory(launch.projectId).then((resp) => {
                    let array = []
                    resp.forEach((ele) => {
                        array.push(ele.unitId)
                    })
                    // if (launch?.pricing?.plc?.length === 0) {
                    //     let views = groupBy(resp, 'view')
                    //     setLaunch((pre) => { pre.pricing.plc = []; return { ...pre } })
                    //     setChildLaunch((pre) => { pre.pricing.plc = []; return { ...pre } })
                    //     Object.keys(views).forEach((e) => {
                    //         setLaunch((pre) => {
                    //             pre.pricing.plc.push({
                    //                 name: e,
                    //                 value: null,
                    //                 type: ''
                    //             })
                    //             return { ...pre }
                    //         })
                    //         setChildLaunch((pre) => {
                    //             pre.pricing.plc.push({
                    //                 name: e,
                    //                 value: null,
                    //                 type: ''
                    //             })
                    //             return { ...pre }
                    //         })
                    //     })
                    // }
                    getLaunchInventory(launch.launchId).then((res) => {
                      
                        getInventoryMerge(launch.projectId).then((merge) => {
                            setAllUnitsToMerge([...merge])
                            let arr = cloneDeep([...merge])
                            setUnitsToMerge([...arr])
                        })
                        if (res.length > 0) {
                            array.forEach((ele) => { ele.wingName = ele.wingId.wingName; ele.show = true; ele.isSelected = false; ele.showCheckbox = true; ele.launchId = launch.launchId })
                            array = groupBy(array, 'wingName')
                            Object.keys(array).forEach((ele) => {
                                array[ele] = {
                                    isSelected: false,
                                    floors: groupBy(array[ele], 'floorNo')
                                }
                                Object.keys(array[ele].floors).forEach((e) => {
                                    array[ele].floors[e] = {
                                        isSelected: false,
                                        units: sortBy(array[ele].floors[e], 'unitNo')
                                    }
                                })
                            })
                            res.forEach((el) => {
                                array[el.wingId.wingName].floors[el.unitId.floorNo].units[array[el.wingId.wingName].floors[el.unitId.floorNo].units.findIndex((e) => e.unitId === el.unitId.unitId)].isSelected = true
                                // if (array[el.wingId.wingName].floors[el.unitId.floorNo].units.length === array[el.wingId.wingName].floors[el.unitId.floorNo].units.filter((e) => e.isSelected === true).length) {
                                if (array[el.wingId.wingName].floors[el.unitId.floorNo].units.filter((e) => e.isSelected === true).length > 0) {
                                    array[el.wingId.wingName].floors[el.unitId.floorNo].isSelected = true
                                }
                                // if (Object.keys(array[el.wingId.wingName].floors).length === Object.keys(array[el.wingId.wingName].floors).filter((e) => { return array[el.wingId.wingName].floors[e].isSelected === true }).length) {
                                if (Object.keys(array[el.wingId.wingName].floors).filter((e) => { return array[el.wingId.wingName].floors[e].isSelected === true }).length > 0) {
                                    array[el.wingId.wingName].isSelected = true
                                }
                            })
                            let newarr = cloneDeep(array)
                            setAllInventory(newarr)
                            setAllChildInventory(array)
                            dismissLoader()
                        } else {
                            let allunits = cloneDeep(array)
                            allunits.forEach((ele) => { ele.wingName = ele.wingId.wingName; ele.show = true; ele.isSelected = false; ele.showCheckbox = false; ele.launchId = launch.launchId })
                            allunits = groupBy(allunits, 'wingName')
                            Object.keys(allunits).forEach((ele) => {
                                allunits[ele] = {
                                    isSelected: false,
                                    floors: groupBy(allunits[ele], 'floorNo')
                                }
                                Object.keys(allunits[ele].floors).forEach((e) => {
                                    allunits[ele].floors[e] = {
                                        isSelected: false,
                                        units: sortBy(allunits[ele].floors[e], 'unitNo')
                                    }
                                })
                            })
                            let newarr1 = cloneDeep(allunits)
                            setAllInventory(newarr1)
                            array.forEach((ele) => { ele.wingName = ele.wingId.wingName; ele.show = true; ele.isSelected = true; ele.showCheckbox = true; ele.launchId = launch.launchId })
                            array = groupBy(array, 'wingName')
                            Object.keys(array).forEach((ele) => {
                                array[ele] = {
                                    isSelected: true,
                                    floors: groupBy(array[ele], 'floorNo')
                                }
                                Object.keys(array[ele].floors).forEach((e) => {
                                    array[ele].floors[e] = {
                                        isSelected: true,
                                        units: sortBy(array[ele].floors[e], 'unitNo')
                                    }
                                })
                            })
                            let newarr = cloneDeep(array)
                            // setAllInventory(newarr)
                            setAllChildInventory(newarr)
                            dismissLoader()
                        }
                    })
                }).catch((err) => {
                    dismissLoader()
                })
            } else {
                let obj = cloneDeep(allInventory)
                setAllChildInventory({ ...obj })
            }
        }
    }, [createLaunch, allUnitsToMerge])

    useEffect(() => {
        console.log(allChildInventory)
        let totalFloorsCount = 0
        let totalUnitsCount = 0
        Object.keys(allChildInventory).forEach((wing) => {
            Object.keys(allChildInventory[wing]).forEach((floor) => {
                totalFloorsCount = totalFloorsCount + Object.keys(allChildInventory[wing][floor]).filter((element) => {
                    totalUnitsCount = totalUnitsCount + allChildInventory[wing][floor][element].units.filter((unit) => { return unit.isSelected === true }).length
                    if (allChildInventory[wing][floor][element].isSelected === true) {
                        setFloorsSelected((pre) => { pre.push(element); return [...pre] })
                    }
                    return allChildInventory[wing][floor][element].isSelected === true
                }).length
                setTotalFloorsSelected(totalFloorsCount)
                setTotalUnitsSelected(totalUnitsCount)
            })
        })
    }, [allChildInventory])

    useEffect(() => {
        if (launch?.pricing?.floorRise.length === 0) {
            setLaunch((pre) => {
                pre?.pricing?.floorRise.push({ from: sortedUniq(floorsSelected)[0], to: null, value: null, type: '' })
                return { ...pre }
            })
            setChildLaunch((pre) => {
                pre?.pricing?.floorRise.push({ from: sortedUniq(floorsSelected)[0], to: null, value: null, type: '' })
                return { ...pre }
            })
        }
    }, [floorsSelected])


    function numberWithCommas(x) {
        return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
    }

    function selectAll() {
        if (createLaunch.timeline[2].isSelected === true) {
            setAllChildSales((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = true;
                })
                return [...pre]
            })
        } else if (createLaunch.timeline[3].isSelected === true) {
            setAllChildCp((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = true;
                })
                return [...pre]
            })
        } else if (createLaunch.timeline[6].isSelected === true) {
            setAllChildPlans((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = true;
                })
                return [...pre]
            })
        } else if (createLaunch.timeline[5].isSelected === true) {
            setAllChildPriceList((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = true;
                })
                return [...pre]
            })
        }
    }

    function deSelectAll() {
        if (createLaunch.timeline[2].isSelected === true) {
            setAllChildSales((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = false;
                })
                return [...pre]
            })
        } else if (createLaunch.timeline[3].isSelected === true) {
            setAllChildCp((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = false;
                })
                return [...pre]
            })
        } else if (createLaunch.timeline[6].isSelected === true) {
            setAllChildPlans((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = false;
                })
                return [...pre]
            })
        } else if (createLaunch.timeline[5].isSelected === true) {
            setAllChildPriceList((pre) => {
                pre.forEach((ele, index) => {
                    pre[index].isSelected = false;
                })
                return [...pre]
            })
        }
    }

    function projectSelected(e, params) {
        if (projectMode === 'add') {
            setProjectId(params.row.id)
            setLaunch((pre) => { pre.projectId = params.row.id; return { ...pre } });
            let arr = cloneDeep(allProjects)
            arr.forEach((e, i) => {
                if (e.id === params.row.id) {
                    e.eventId = eventId
                } else {
                    e.eventId = null
                }
            })
            SetAllProjects([...arr])
        } else {
            setProjectId(params.row.id)
            let arr = cloneDeep(allProjects)
            arr.forEach((e, i) => {
                if (e.id === params.row.id) {
                    e.eventId = eventId
                } else {
                    e.eventId = null
                }
            })
            SetAllProjects([...arr])
        }
    }

    function launchTitleChanged(e) {
        if (e.replace(/\s\s+/g, " ").trim() === '') {
            setLaunchTitleHelperText('Please Enter Launch Title')
        } else {
            setLaunchTitleHelperText('')
        }
        if (projectMode === 'add') {
            // var alphabet = /^[A-Z*\sa-z]*$/;
            // if (e.match(alphabet)) {
            setLaunchTitle(e.replace(/\s\s+/g, " "));
            setLaunch((pre) => {
                pre.title = e.replace(/\s\s+/g, " ");
                return { ...pre }
            });
            // }
        } else {
            setLaunchTitle(e.replace(/\s\s+/g, " "));
        }
    }

    function tabChanged(e, value) {
        let index = createLaunch.timeline.findIndex((e) => e.value === value)
        if (!launch.launchId && index > 1) {
            errorTost("Please complete and save steps 1 & 2 and then proceed")
            searchParams.set('submenu', 'Add Launch Title')
            setSearchParams(searchParams)
        } else {
            if (createLaunch.timeline[0].isSelected === true) {
                // var alphabet = /^[A-Z*\sa-z]*$/;
                // if (!launch.title.match(alphabet) || launch.title.replace(/\s\s+/g, " ") === '') {
                if (launchTitleHelperText !== '') {
                    searchParams.set('submenu', 'Add Launch Title')
                    setSearchParams(searchParams)
                } else {
                    if (launchTitle.replace(/\s\s+/g, " ") === '' && index !== 0) {
                        console.log(launchId)
                        setLaunchTitleHelperText('Please Enter Launch Title')
                        searchParams.set('submenu', 'Add Launch Title')
                        setSearchParams(searchParams)
                    } else if (launch.title !== launchTitle && index !== 0) {
                        setClickedIndex(index)
                        setOpenAlert(true)
                        // searchParams.set('submenu', 'Add Launch Title')
                        // setSearchParams(searchParams)
                    } else {
                        setCreateLaunch((pre) => { pre.timeline[0].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                    }
                }
            } else if (createLaunch.timeline[1].isSelected === true && index !== 1) {
                if (launch.projectId === '' && value !== 'Add Launch Title') {
                    errorTost('Please select a project and save')
                    searchParams.set('submenu', 'Select Project')
                    setSearchParams(searchParams)
                } else if (launch.projectId !== projectId && index !== 1) {
                    setClickedIndex(index)
                    setOpenAlert(true)
                    // searchParams.set('submenu', 'Select Project')
                    // setSearchParams(searchParams)
                } else {
                    if (index !== 1) {
                        setSearchProject('')
                    }
                    setCreateLaunch((pre) => { pre.timeline[1].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                }
            } else if (createLaunch.timeline[2].isSelected === true) {
                if (!isEqual(allChildSales, allSales) && index !== 2) {
                    setClickedIndex(index)
                    setOpenAlert(true)
                    // searchParams.set('submenu', 'Select Sales')
                    // setSearchParams(searchParams)
                } else {
                    if (index !== 2) {
                        setSearchSales('')
                    }
                    setCreateLaunch((pre) => { pre.timeline[2].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                }
            } else if (createLaunch.timeline[3].isSelected === true) {
                if (!isEqual(allChildCp, allCp) && index !== 3) {
                    setClickedIndex(index)
                    setOpenAlert(true)
                    // searchParams.set('submenu', 'Select Cp')
                    // setSearchParams(searchParams)
                } else {
                    if (index !== 3) {
                        setSearchCp('')
                    }
                    setCreateLaunch((pre) => { pre.timeline[3].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                }
            } else if (createLaunch.timeline[4].isSelected === true) {
                if (showMerge) {
                    if (!isEqual(allUnitsToMerge, unitsToMerge) && index !== 4) {
                        setClickedIndex(index)
                        setOpenAlert(true)
                        // searchParams.set('submenu', 'Select Inventory')
                        // setSearchParams(searchParams)
                    } else {
                        setShowMerge(false)
                        searchParams.set('submenu', 'Select Inventory')
                        setSearchParams(searchParams)
                        // setCreateLaunch((pre) => { pre.timeline[4].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                    }
                } else {
                    console.log(allChildInventory)
                    console.log(allInventory)
                    if (!isEqual(allChildInventory, allInventory) && index !== 4) {
                        setClickedIndex(index)
                        setOpenAlert(true)
                    } else {
                        setCreateLaunch((pre) => { pre.timeline[4].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                    }
                }
            } else if (createLaunch.timeline[5].isSelected === true) {
                if (!isEqual(allChildPriceList, allPriceList) && index !== 5) {
                    setClickedIndex(index)
                    setOpenAlert(true)
                    // searchParams.set('submenu', 'Select Cp')
                    // setSearchParams(searchParams)
                } else {
                    if (index !== 5) {
                        setSearchPlan('')
                    }
                    setCreateLaunch((pre) => { pre.timeline[5].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                }

            } else if (createLaunch.timeline[6].isSelected === true) {
                if (!isEqual(allChildPlans, allPlans) && index !== 6) {
                    setClickedIndex(index)
                    setOpenAlert(true)
                    // searchParams.set('submenu', 'Select Cp')
                    // setSearchParams(searchParams)
                } else {
                    if (index !== 6) {
                        setSearchPlan('')
                    }
                    setCreateLaunch((pre) => { pre.timeline[6].isSelected = false; pre.timeline[index].isSelected = true; return { ...pre } })
                }
            } else {
                setCreateLaunch((pre) => {
                    pre.timeline[createLaunch.timeline.findIndex((e) => e.isSelected === true)].isSelected = false;
                    pre.timeline[index].isSelected = true; return { ...pre }
                })
            }
        }
    }

    function nextStep() {
        setLaunch((pre) => { pre.title = launchTitle; pre.projectId = projectId; return { ...pre } })
        if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Add Launch Title') {
            if (launch.title.trim() === '') {
                setLaunchTitleHelperText("Please Enter Launch Title")
                setLaunch((pre) => { pre.title = ''; return { ...pre } });
                searchParams.set('submenu', 'Add Launch Title')
                setSearchParams(searchParams)
            } else {
                getLaunchByTitle(launch.title.trim(), eventId).then((resp) => {
                    console.log(resp)
                    if (resp.length === 0) {
                        if (!launch.completedTabs.includes('Add Launch Title')) {
                            setLaunch((pre) => { pre.completedTabs.push('Add Launch Title'); return { ...pre } })
                        }
                        if (projectMode === 'edit') {
                            presentLoader()
                            editLaunch({ title: launch.title }, launch.launchId).then((res) => {
                                setLaunchTitleHelperText('')
                                setCreateLaunch((pre) => { pre.timeline[1].isSelected = true; pre.timeline[0].isSelected = false; return { ...pre } })
                                searchParams.set('submenu', 'Select Project')
                                setSearchParams(searchParams)
                                dismissLoader()
                            })
                        } else {
                            setLaunchTitleHelperText('')
                            setCreateLaunch((pre) => { pre.timeline[1].isSelected = true; pre.timeline[0].isSelected = false; return { ...pre } })
                            searchParams.set('submenu', 'Select Project')
                            setSearchParams(searchParams)
                        }
                    } else {
                        setLaunchTitleHelperText("Launch Title already present please enter new launch title")
                    }
                })
            }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select Project') {
            if (launch.projectId === '') {
                errorTost('Please select a project')
                searchParams.set('submenu', 'Select Project')
                setSearchParams(searchParams)
            } else {
                if (allProjects.filter((e) => { return e.projectId === launch.projectId })[0].useCsvPrice) {
                    setUseCsv(true)
                } else {
                    setUseCsv(false)
                }
                if (!launch.completedTabs.includes('Select Project')) {
                    setLaunch((pre) => { pre.completedTabs.push('Select Project'); return { ...pre } })
                }
                if (projectMode === 'add') {
                    getLaunchByTitle(launch.title.trim(), eventId).then((resp) => {
                        if (resp.length === 0) {
                            launch.completedTabs = ["Add Launch Title", "Select Project"]
                            presentLoader()
                            addLaunch(launch).then((resp) => {
                                setSearchParams((pre) => { pre.launch = resp[0].launchId; return { ...pre } })
                                setProjectMode('edit')
                                setLaunch((pre) => { pre.launchId = resp[0].launchId; return { ...pre } })
                                setCreateLaunch((pre) => { pre.timeline[2].isSelected = true; pre.timeline[1].isSelected = false; return { ...pre } })
                                searchParams.set('submenu', 'Select Sales')
                                setSearchParams(searchParams)
                                dismissLoader()
                            }).catch((err) => {
                                errorTost("Something went wrong please try again later")
                                dismissLoader()
                            })
                        } else {
                            setSearchParams((pre) => { pre.launch = resp[0].launchId; return { ...pre } })
                            searchParams.set('submenu', 'Add Launch Title')
                            setSearchParams(searchParams)
                            setLaunchTitleHelperText("Launch Title already present please enter new launch title")
                        }
                    })
                } else {
                    presentLoader()
                    editLaunch({
                        projectId: launch.projectId
                    }, launch.launchId).then((res) => {
                        deleteInventoryRelationsOfLaunch(launch.launchId).then((resp) => {
                            setCreateLaunch((pre) => { pre.timeline[2].isSelected = true; pre.timeline[1].isSelected = false; return { ...pre } })
                            searchParams.set('submenu', 'Select Sales')
                            setSearchParams(searchParams)
                            setAllChildInventory([])
                            setAllInventory([])
                            setAllUnitsToMerge([])
                            dismissLoader()
                        })
                    })
                }

            }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select Cp') {
            let allExistingCp = allCp.filter((e) => { return e.isSelected === true })
            let arr = allChildCp.filter((e) => { return e.isSelected === true })
            if (arr.length === 0) {
                let newarr = cloneDeep(allCp)
                setAllChildCp([...newarr])
                errorTost("Please select atleast one Cp and then save")
                searchParams.set('submenu', 'Select Cp')
                setSearchParams(searchParams)
            } else {
                if (!launch.completedTabs.includes('Select Cp')) {
                    setLaunch((pre) => { pre.completedTabs.push('Select Cp'); return { ...pre } })
                }
                let newarr = cloneDeep(allChildCp)
                setAllCp([...newarr])
                presentLoader()
                if (allExistingCp.length > 0) {
                    let insertarr = differenceWith(arr, allExistingCp, isEqual)
                    let deletearr = differenceWith(allExistingCp, arr, isEqual)
                    if (insertarr.length > 0) {
                        insertarr.forEach((element, index) => {
                            insertIntoCpRelations({ launchId: launch.launchId, cpId: element.cpId }).then((resp) => {
                                setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === element.cpId)].isSelected = true; return [...pre] })
                                if (index === insertarr.length - 1) {
                                    if (deletearr.length > 0) {
                                        deletearr.forEach((ele, index2) => {
                                            deleteCpRelations(ele, launch.launchId).then((res) => {
                                                if (index2 === deletearr.length - 1) {
                                                    setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === element.cpId)].isSelected = false; return [...pre] })
                                                    setCreateLaunch((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
                                                    setLaunch((pre) => { if (!pre.completedTabs.includes('Select Cp')) { pre.completedTabs.push('Select Cp') } return { ...pre } })
                                                    successTost("Cp Team saved successfully")
                                                    setSearchCp('')
                                                    searchParams.set('submenu', 'Select Inventory')
                                                    setSearchParams(searchParams)
                                                    dismissLoader()
                                                }
                                            })
                                        })
                                    } else {
                                        setCreateLaunch((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
                                        setLaunch((pre) => { if (!pre.completedTabs.includes('Select Cp')) { pre.completedTabs.push('Select Cp') } return { ...pre } })
                                        successTost("Cp Team saved successfully")
                                        setSearchCp('')
                                        searchParams.set('submenu', 'Select Inventory')
                                        setSearchParams(searchParams)
                                        dismissLoader()
                                    }
                                }
                            })
                        })
                    } else if (deletearr.length > 0) {
                        deletearr.forEach((ele, index2) => {
                            deleteCpRelations(ele, launch.launchId).then((res) => {
                                if (index2 === deletearr.length - 1) {
                                    setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === ele.cpId)].isSelected = false; return [...pre] }); setCreateLaunch((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
                                    setLaunch((pre) => { if (!pre.completedTabs.includes('Select Cp')) { pre.completedTabs.push('Select Cp') } return { ...pre } })
                                    successTost("Cp Team saved successfully")
                                    setSearchCp('')
                                    searchParams.set('submenu', 'Select Inventory')
                                    setSearchParams(searchParams)
                                    dismissLoader()
                                }
                            })
                        })
                    } else {
                        successTost("Cp Team saved successfully")
                        setLaunch((pre) => { if (!pre.completedTabs.includes('Select Cp')) { pre.completedTabs.push('Select Cp') } return { ...pre } })
                        setCreateLaunch((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
                        setSearchCp('')
                        searchParams.set('submenu', 'Select Inventory')
                        setSearchParams(searchParams)
                        dismissLoader()
                    }
                } else {
                    arr.forEach((ele, index) => {
                        insertIntoCpRelations({ launchId: launch.launchId, cpId: ele.cpId }).then((resp) => {
                            setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === ele.cpId)].isSelected = true; return [...pre] });
                            if (index === arr.length - 1) {
                                setCreateLaunch((pre) => { pre.timeline[4].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
                                setLaunch((pre) => { if (!pre.completedTabs.includes('Select Cp')) { pre.completedTabs.push('Select Cp') } return { ...pre } })
                                successTost("Cp Team saved successfully")
                                setSearchCp('')
                                searchParams.set('submenu', 'Select Inventory')
                                setSearchParams(searchParams)
                                dismissLoader()
                            }
                        })
                    })
                }
            }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select Sales') {
            let allExistingSales = allSales.filter((e) => { return e.isSelected === true })
            let arr = allChildSales.filter((e) => { return e.isSelected === true })
            if (arr.length === 0) {
                let newarr = cloneDeep(allSales)
                setAllChildSales([...newarr])
                errorTost("Please select atleast one Sales person and then save")
                searchParams.set('submenu', 'Select Sales')
                setSearchParams(searchParams)
            } else {
                if (!launch.completedTabs.includes('Select Sales')) {
                    setLaunch((pre) => { pre.completedTabs.push('Select Sales'); return { ...pre } })
                }
                let newarr = cloneDeep(allChildSales)
                setAllSales([...newarr])
                presentLoader()
                if (allExistingSales.length > 0) {
                    let insertarr = differenceWith(arr, allExistingSales, isEqual)
                    let deletearr = differenceWith(allExistingSales, arr, isEqual)
                    if (insertarr.length > 0) {
                        insertarr.forEach((element, index) => {
                            insertIntoSalesRelations({ launchId: launch.launchId, userId: element.userId }).then((resp) => {
                                setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === element.userId)].isSelected = true; return [...pre] })
                                if (index === insertarr.length - 1) {
                                    if (deletearr.length > 0) {
                                        deletearr.forEach((ele, index2) => {
                                            deleteSalesRelations(ele, launch.launchId).then((res) => {
                                                if (index2 === deletearr.length - 1) {
                                                    setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === element.userId)].isSelected = false; return [...pre] })
                                                    successTost("Sales Team saved successfully")
                                                    setCreateLaunch((pre) => { pre.timeline[3].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
                                                    setSearchSales('')
                                                    searchParams.set('submenu', 'Select Cp')
                                                    setSearchParams(searchParams)
                                                    dismissLoader()
                                                }
                                            })
                                        })
                                    } else {
                                        setCreateLaunch((pre) => { pre.timeline[3].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
                                        successTost("Sales Team saved successfully")
                                        setSearchSales('')
                                        searchParams.set('submenu', 'Select Cp')
                                        setSearchParams(searchParams)
                                        dismissLoader()
                                    }
                                }
                            })
                        })
                    } else if (deletearr.length > 0) {
                        deletearr.forEach((ele, index2) => {
                            deleteSalesRelations(ele, launch.launchId).then((res) => {
                                if (index2 === deletearr.length - 1) {
                                    setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === ele.userId)].isSelected = false; return [...pre] }); setCreateLaunch((pre) => { pre.timeline[3].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
                                    successTost("Sales Team saved successfully")
                                    setSearchSales('')
                                    searchParams.set('submenu', 'Select Cp')
                                    setSearchParams(searchParams)
                                    dismissLoader()
                                }
                            })
                        })
                    } else {
                        successTost("Sales Team saved successfully")
                        setCreateLaunch((pre) => { pre.timeline[3].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
                        setSearchSales('')
                        searchParams.set('submenu', 'Select Cp')
                        setSearchParams(searchParams)
                        dismissLoader()
                    }
                } else {
                    arr.forEach((ele, index) => {
                        insertIntoSalesRelations({ launchId: launch.launchId, userId: ele.userId }).then((resp) => {
                            setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === ele.userId)].isSelected = true; return [...pre] });
                            if (index === arr.length - 1) {
                                setCreateLaunch((pre) => { pre.timeline[3].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
                                successTost("Sales Team saved successfully")
                                setSearchSales('')
                                searchParams.set('submenu', 'Select Cp')
                                setSearchParams(searchParams)
                                dismissLoader()
                            }
                        })
                    })
                }
            }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select Inventory') {
            if (showMerge) {
                let insertarr = differenceWith(unitsToMerge, allUnitsToMerge, isEqual)
                let deletearr = differenceWith(allUnitsToMerge, unitsToMerge, isEqual)
                console.log(deletearr)
                console.log(insertarr)
                if (insertarr.length > 0) {
                    insertarr.forEach((element, index) => {
                        insertIntoInventoryMerge({ unit1Id: element.unit1Id, unit2Id: element.unit2Id, unit1No: element.unit1No, unit2No: element.unit2No, launchId: launchId }).then((resp) => {
                            updateInventory({ inventoryMergeId: resp.data[0].inventoryMergeId }, resp.data[0].unit1Id).then((i1) => {
                                updateInventory({ inventoryMergeId: resp.data[0].inventoryMergeId }, resp.data[0].unit2Id).then((i2) => {
                                    updateInventoryRelations({ mergeId: resp.data[0].inventoryMergeId }, launchId, resp.data[0].unit1Id).then((unit1) => {
                                        updateInventoryRelations({ mergeId: resp.data[0].inventoryMergeId }, launchId, resp.data[0].unit2Id).then((unit2) => {
                                            if (index === insertarr.length - 1) {
                                                if (deletearr.length > 0) {
                                                    deletearr.forEach((ele, index2) => {
                                                        updateInventory({ inventoryMergeId: null }, ele.unit1Id).then((resp) => {
                                                            updateInventory({ inventoryMergeId: null }, ele.unit2Id).then((resp) => {
                                                                updateInventoryRelations({ mergeId: null }, launchId, ele.unit1Id).then((resp) => {
                                                                    updateInventoryRelations({ mergeId: null }, launchId, ele.unit2Id).then((resp) => {
                                                                        deleteInventoryMerge(ele.inventoryMergeId).then((res) => {
                                                                            if (index2 === deletearr.length - 1) {
                                                                                setAllUnitsToMerge([])
                                                                                setAllInventory([])
                                                                                successTost("Merge/Demerge done successfully")
                                                                                setShowMerge(false)
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                } else {
                                                    setAllUnitsToMerge([])
                                                    setAllInventory([])
                                                    setShowMerge(false)
                                                    successTost("Merge/Demerge done successfully")
                                                }
                                            }
                                        })
                                    })
                                })
                            })
                        })
                    })
                } else if (deletearr.length > 0) {
                    deletearr.forEach((ele, index2) => {
                        updateInventory({ inventoryMergeId: null }, ele.unit1Id).then((resp) => {
                            updateInventory({ inventoryMergeId: null }, ele.unit2Id).then((resp) => {
                                updateInventoryRelations({ mergeId: null }, launchId, ele.unit1Id).then((resp) => {
                                    updateInventoryRelations({ mergeId: null }, launchId, ele.unit2Id).then((resp) => {
                                        deleteInventoryMerge(ele.inventoryMergeId).then((res) => {
                                            if (index2 === deletearr.length - 1) {
                                                setAllUnitsToMerge([])
                                                setAllInventory([])
                                                successTost("Merge/Demerge done successfully")
                                                setShowMerge(false)
                                            }
                                        })
                                    })
                                })
                            })
                        })
                    })
                } else {
                    setShowMerge(false)
                }
            } else {
                let allUnitsArr = []
                let allChildUnitsArr = []
                Object.keys(allInventory).forEach((wing) => {
                    Object.keys(allInventory[wing].floors).forEach((floor) => {
                        allInventory[wing].floors[floor].units.forEach((unit) => {
                            if (unit.isSelected === true)
                                allUnitsArr.push(unit)
                        })
                    })
                })
                Object.keys(allChildInventory).forEach((wing) => {
                    Object.keys(allChildInventory[wing].floors).forEach((floor) => {
                        allChildInventory[wing].floors[floor].units.forEach((unit) => {
                            if (unit.isSelected === true)
                                allChildUnitsArr.push(unit)
                        })
                    })
                })
                if (allChildUnitsArr.length === 0) {
                    let newarr = cloneDeep(allInventory)
                    setAllChildInventory({ ...newarr })
                    errorTost("Please select atleast one unit and then save")
                    searchParams.set('submenu', 'Select Inventory')
                    setSearchParams(searchParams)
                } else {
                    if (!launch.completedTabs.includes('Select Inventory')) {
                        setLaunch((pre) => { pre.completedTabs.push('Select Inventory'); return { ...pre } })
                    }
                    let newarr = cloneDeep(allChildInventory)
                    setAllInventory({ ...newarr })
                    presentLoader()
                    if (allChildUnitsArr.length > 0) {
                        let deletearr = differenceWith(allUnitsArr, allChildUnitsArr, isEqual)
                        let insertarr = differenceWith(allChildUnitsArr, allUnitsArr, isEqual)
                        if (insertarr.length > 0) {
                            insertarr.forEach((element, index) => {
                                console.log(element)
                                insertIntoInventoryRelations({ launchId: launch.launchId, unitId: element.unitId, wingId: element.wingId.wingId, mergeId: element.inventoryMergeId ? element.inventoryMergeId.inventoryMergeId : null }, eventId).then((resp) => {
                                    // setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === element.userId)].isSelected = true; return [...pre] })
                                    if (index === insertarr.length - 1) {
                                        if (deletearr.length > 0) {
                                            deletearr.forEach((ele, index2) => {
                                                deleteInventoryRelations(ele, launch.launchId, eventId).then((res) => {
                                                    if (index2 === deletearr.length - 1) {
                                                        // setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === element.userId)].isSelected = false; return [...pre] })
                                                        successTost("Inventory saved successfully")
                                                        if (useCsv) {
                                                            setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                                            searchParams.set('submenu', 'Preview Inventory')
                                                            setSearchParams(searchParams)
                                                        } else {
                                                            setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                                            searchParams.set('submenu', 'Select PriceList')
                                                            setSearchParams(searchParams)
                                                        }
                                                        dismissLoader()
                                                    }
                                                })
                                            })
                                        } else {
                                            successTost("Inventory saved successfully")
                                            if (useCsv) {
                                                setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                                searchParams.set('submenu', 'Preview Inventory')
                                                setSearchParams(searchParams)
                                            } else {
                                                setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                                searchParams.set('submenu', 'Select PriceList')
                                                setSearchParams(searchParams)
                                            }
                                            dismissLoader()
                                        }
                                    }
                                })
                            })
                        } else if (deletearr.length > 0) {
                            deletearr.forEach((ele, index2) => {
                                deleteInventoryRelations(ele, launch.launchId, eventId).then((res) => {
                                    if (index2 === deletearr.length - 1) {
                                        // setAllSales((pre) => { pre[pre.findIndex((e) => e.userId === ele.userId)].isSelected = false; return [...pre] });
                                        successTost("Inventory saved successfully")
                                        if (useCsv) {
                                            setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                            searchParams.set('submenu', 'Preview Inventory')
                                            setSearchParams(searchParams)
                                        } else {
                                            setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                            searchParams.set('submenu', 'Select PriceList')
                                            setSearchParams(searchParams)
                                        }
                                        dismissLoader()
                                    }
                                })
                            })
                        } else {
                            successTost("Inventory saved successfully")
                            if (useCsv) {
                                setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                searchParams.set('submenu', 'Preview Inventory')
                                setSearchParams(searchParams)
                            } else {
                                setCreateLaunch((pre) => { pre.timeline[5].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                                searchParams.set('submenu', 'Select PriceList')
                                setSearchParams(searchParams)
                            }
                            dismissLoader()
                        }
                    }
                }
            }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select PriceList') {
            let allExistingPriceList = allPriceList.filter((e) => { return e.isSelected === true })
            let arr = allChildPriceList.filter((e) => { return e.isSelected === true })
            if (arr.length === 0) {
                let newarr = cloneDeep(allPriceList)
                setAllChildPriceList([...newarr])
                errorTost("Please select atleast one Price and then save")
                searchParams.set('submenu', 'Select Payment Plans')
                setSearchParams(searchParams)
            } 
            if (!launch.completedTabs.includes('Select PriceList')) {
                setLaunch((pre) => { pre.completedTabs.push('Select PriceList'); return { ...pre } })
            }
            let newarr = cloneDeep(allChildPriceList)
            setAllPriceList([...newarr])
            presentLoader()
            if (allExistingPriceList.length > 0) {
                let insertarr = differenceWith(arr, allExistingPriceList, isEqual)
                let deletearr = differenceWith(allExistingPriceList, arr, isEqual)
                if (insertarr.length > 0) {
                    insertarr.forEach((element, index) => {
                        insertIntoPriceListRelations({ launchId: launch.launchId, projectPricingId: element.projectPricingId }).then((resp) => {
                            setAllPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === element.projectPricingId)].isSelected = true; return [...pre] })
                            if (index === insertarr.length - 1) {
                                if (deletearr.length > 0) {
                                    deletearr.forEach((ele, index2) => {
                                        deletePriceListRelations(ele, launch.launchId).then((res) => {
                                            if (index2 === deletearr.length - 1) {
                                                setAllPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === element.projectPricingId)].isSelected = false; return [...pre] })
                                                setCreateLaunch((pre) => { pre.timeline[6].isSelected = true; pre.timeline[5].isSelected = false; return { ...pre } })
                                                setLaunch((pre) => { if (!pre.completedTabs.includes('Select PriceList')) { pre.completedTabs.push('Select PriceList') } return { ...pre } })
                                                successTost("PriceList saved successfully")
                                                setSearchPriceList('')
                                                searchParams.set('submenu', 'Select Payment Plans')
                                                setSearchParams(searchParams)
                                                dismissLoader()
                                            }
                                        })
                                    })
                                } else {
                                    setCreateLaunch((pre) => { pre.timeline[6].isSelected = true; pre.timeline[5].isSelected = false; return { ...pre } })
                                    setLaunch((pre) => { if (!pre.completedTabs.includes('Select PriceList')) { pre.completedTabs.push('Select PriceList') } return { ...pre } })
                                    successTost("PriceList saved successfully")
                                    setSearchPriceList('')
                                    searchParams.set('submenu', 'Select Payment Plans')
                                    setSearchParams(searchParams)
                                    dismissLoader()
                                }
                            }
                        })
                    })
                } else if (deletearr.length > 0) {
                    deletearr.forEach((ele, index2) => {
                        deletePriceListRelations(ele, launch.launchId).then((res) => {
                            if (index2 === deletearr.length - 1) {
                                setAllPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)].isSelected = false; return [...pre] }); setCreateLaunch((pre) => { pre.timeline[6].isSelected = true; pre.timeline[5].isSelected = false; return { ...pre } })
                                setLaunch((pre) => { if (!pre.completedTabs.includes('Select PriceList')) { pre.completedTabs.push('Select PriceList') } return { ...pre } })
                                successTost("PriceList saved successfully")
                                setSearchPriceList('')
                                searchParams.set('submenu', 'Select Payment Plans')
                                setSearchParams(searchParams)
                                dismissLoader()
                            }
                        })
                    })
                } else {
                    successTost("PriceList saved successfully")
                    setLaunch((pre) => { if (!pre.completedTabs.includes('Select PriceList')) { pre.completedTabs.push('Select PriceList') } return { ...pre } })
                    setCreateLaunch((pre) => { pre.timeline[6].isSelected = true; pre.timeline[5].isSelected = false; return { ...pre } })
                    setSearchPriceList('')
                    searchParams.set('submenu', 'Select Payment Plans')
                    setSearchParams(searchParams)
                    dismissLoader()
                }
            } else {
                arr.forEach((ele, index) => {
                    insertIntoPriceListRelations({ launchId: launch.launchId, projectPricingId: ele.projectPricingId }).then((resp) => {
                        setAllPriceList((pre) => { pre[pre.findIndex((e) => e.projectPricingId === ele.projectPricingId)].isSelected = true; return [...pre] });
                        if (index === arr.length - 1) {
                            setCreateLaunch((pre) => { pre.timeline[6].isSelected = true; pre.timeline[5].isSelected = false; return { ...pre } })
                            setLaunch((pre) => { if (!pre.completedTabs.includes('Select PriceList')) { pre.completedTabs.push('Select PriceList') } return { ...pre } })
                            successTost("PriceList saved successfully")
                            setSearchPriceList('')
                            searchParams.set('submenu', 'Select Payment Plans')
                            setSearchParams(searchParams)
                            dismissLoader()
                        }
                    })
                })
            }
            // }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Select Payment Plans') {
            let allExistingPlans = allPlans.filter((e) => { return e.isSelected === true })
            let arr = allChildPlans.filter((e) => { return e.isSelected === true })
            // if (arr.length === 0) {
            //     let newarr = cloneDeep(allPlans)
            //     setAllChildPlans([...newarr])
            //     errorTost("Please select atleast one Plan and then save")
            //     searchParams.set('submenu', 'Select Payment Plans')
            //     setSearchParams(searchParams)
            // } else {
            if (!launch.completedTabs.includes('Select Payment Plans')) {
                setLaunch((pre) => { pre.completedTabs.push('Select Payment Plans'); return { ...pre } })
            }
            let newarr = cloneDeep(allChildPlans)
            setAllPlans([...newarr])
            presentLoader()
            if (allExistingPlans.length > 0) {
                let insertarr = differenceWith(arr, allExistingPlans, isEqual)
                let deletearr = differenceWith(allExistingPlans, arr, isEqual)
                if (insertarr.length > 0) {
                    insertarr.forEach((element, index) => {
                        insertIntoPaymentRelations({ launchId: launch.launchId, paymentPlanId: element.paymentPlanId }).then((resp) => {
                            setAllPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === element.paymentPlanId)].isSelected = true; return [...pre] })
                            if (index === insertarr.length - 1) {
                                if (deletearr.length > 0) {
                                    deletearr.forEach((ele, index2) => {
                                        deletePaymentRelations(ele, launch.launchId).then((res) => {
                                            if (index2 === deletearr.length - 1) {
                                                setAllPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === element.paymentPlanId)].isSelected = false; return [...pre] })
                                                setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[6].isSelected = false; return { ...pre } })
                                                setLaunch((pre) => { if (!pre.completedTabs.includes('Select Payment Plans')) { pre.completedTabs.push('Select Payment Plans') } return { ...pre } })
                                                successTost("Payment Plans saved successfully")
                                                setSearchPlan('')
                                                searchParams.set('submenu', 'Preview Inventory')
                                                setSearchParams(searchParams)
                                                dismissLoader()
                                            }
                                        })
                                    })
                                } else {
                                    setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[6].isSelected = false; return { ...pre } })
                                    setLaunch((pre) => { if (!pre.completedTabs.includes('Select Payment Plans')) { pre.completedTabs.push('Select Payment Plans') } return { ...pre } })
                                    successTost("Payment Plans saved successfully")
                                    setSearchPlan('')
                                    searchParams.set('submenu', 'Preview Inventory')
                                    setSearchParams(searchParams)
                                    dismissLoader()
                                }
                            }
                        })
                    })
                } else if (deletearr.length > 0) {
                    deletearr.forEach((ele, index2) => {
                        deletePaymentRelations(ele, launch.launchId).then((res) => {
                            if (index2 === deletearr.length - 1) {
                                setAllPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].isSelected = false; return [...pre] }); setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[6].isSelected = false; return { ...pre } })
                                setLaunch((pre) => { if (!pre.completedTabs.includes('Select Payment Plans')) { pre.completedTabs.push('Select Payment Plans') } return { ...pre } })
                                successTost("Payment Plans saved successfully")
                                setSearchPlan('')
                                searchParams.set('submenu', 'Preview Inventory')
                                setSearchParams(searchParams)
                                dismissLoader()
                            }
                        })
                    })
                } else {
                    successTost("Payment Plans saved successfully")
                    setLaunch((pre) => { if (!pre.completedTabs.includes('Select Payment Plans')) { pre.completedTabs.push('Select Payment Plans') } return { ...pre } })
                    setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[6].isSelected = false; return { ...pre } })
                    setSearchPlan('')
                    searchParams.set('submenu', 'Preview Inventory')
                    setSearchParams(searchParams)
                    dismissLoader()
                }
            } else {
                arr.forEach((ele, index) => {
                    insertIntoPaymentRelations({ launchId: launch.launchId, paymentPlanId: ele.paymentPlanId }).then((resp) => {
                        setAllPlans((pre) => { pre[pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)].isSelected = true; return [...pre] });
                        if (index === arr.length - 1) {
                            setCreateLaunch((pre) => { pre.timeline[7].isSelected = true; pre.timeline[6].isSelected = false; return { ...pre } })
                            setLaunch((pre) => { if (!pre.completedTabs.includes('Select Payment Plans')) { pre.completedTabs.push('Select Payment Plans') } return { ...pre } })
                            successTost("Payment Plans saved successfully")
                            setSearchPlan('')
                            searchParams.set('submenu', 'Preview Inventory')
                            setSearchParams(searchParams)
                            dismissLoader()
                        }
                    })
                })
            }
            // }
        } else if (createLaunch.timeline.filter((e) => { return e.isSelected === true })[0].text === 'Preview Inventory') {
            navigate(`/home/Event/ConfigureEvent/${eventId}`)
        } 
    }

    function ModalResp(e) {
        setOpenAlert(false)
        let index = createLaunch.timeline.findIndex((e) => e.isSelected === true)
        if (e === 'confirmed') {
            if (index === 0) {
                setLaunchTitle(launch.title)
                if (launch.title.trim() === '') {
                    setLaunchTitleHelperText('Please Enter Launch Title')
                } else {
                    setLaunchTitleHelperText('')
                }
                setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[0].isSelected = false; return { ...pre } })
            } else if (index === 1) {
                setSearchProject('')
                setProjectId(launch.projectId)
                SetAllProjects((pre) => {
                    pre[pre.findIndex((e) => e.eventId)].eventId = null;
                    pre[pre.findIndex((e) => e.projectId === launch.projectId)].eventId = eventId;
                    return [...pre]
                })
                setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[1].isSelected = false; return { ...pre } })
            } else if (index === 2) {
                setSearchSales('')
                let newarr = cloneDeep(allSales)
                setAllChildSales(newarr)
                setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[2].isSelected = false; return { ...pre } })
            } else if (index === 3) {
                setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[3].isSelected = false; return { ...pre } })
                setSearchCp('')
                allCp.forEach((e, index) => {
                    setAllCp((pre) => {
                        pre[index].show = true;
                        return [...pre]
                    })
                })
                let arr = cloneDeep(allCp)
                setAllChildCp(arr)
            } else if (index === 4) {
                if (showMerge) {
                    let arr = cloneDeep([...allUnitsToMerge])
                    setUnitsToMerge([...arr])
                    setShowMerge(false)
                } else {
                    setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[4].isSelected = false; return { ...pre } })
                    let obj = cloneDeep(allInventory)
                    setAllChildInventory(obj)
                }
            } else if (index === 5) {
                setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[5].isSelected = false; return { ...pre } })
                setSearchPriceList('')
                allPriceList.forEach((e, index) => {
                    setAllPriceList((pre) => {
                        pre[index].show = true;
                        return [...pre]
                    })
                })
                let arr = cloneDeep(allPriceList)
                setAllChildPriceList(arr)
            } else if (index === 6) {
                setCreateLaunch((pre) => { pre.timeline[clickedIndex].isSelected = true; pre.timeline[6].isSelected = false; return { ...pre } })
                setSearchPlan('')
                allPlans.forEach((e, index) => {
                    setAllPlans((pre) => {
                        pre[index].show = true;
                        return [...pre]
                    })
                })
                let arr = cloneDeep(allPlans)
                setAllChildPlans(arr)
            }
            console.log(createLaunch)
            searchParams.set('submenu', createLaunch.timeline[clickedIndex].value)
            setSearchParams(searchParams)
        } else {
            searchParams.set('submenu', createLaunch.timeline[index].value)
            setSearchParams(searchParams)
        }
    }

    return (
        <div className={cssClasses.mainContainer}>
            <div style={{ height: "calc(100% - 4rem)" }}>
                {/* <div style={{ height: "calc(100% - 6rem)" }}> */}
                {/* <div className={cssClasses.header}>
                    <div className={cssClasses.titleWrapper}>
                        <div className={cssClasses.title}>
                            <p>Create Launch</p>
                        </div>
                    </div>
                    <div className={}>
                    <div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </div>
                </div> */}
                <div className={cssClasses.content}>
                    <div className={cssClasses.progressCardWrapper}>
                        <div className={cssClasses.progressCard}>
                            <ProgressCard defaultExpanded={false} image={createLaunch.image} totalProgress={createLaunch.totalProgress} currentProgress={uniq(launch?.completedTabs).length} timeline={!useCsv ? createLaunch.timeline : createLaunch.timeline.filter((e) => { return e.value !== 'Select Payment Plans' && e.value !== 'Select PriceList' })} cardTitle={createLaunch.title} />
                        </div>
                    </div>
                    <div className={cssClasses.tabsWrapper}>
                        <Box className={cssClasses.TabsWrapper} style={{ height: "100%" }}>
                            <TabContext value={createLaunch.timeline.find(f => f.isSelected).value}>
                                <TabsMenu
                                    selectedColor={"#1570EF"}
                                    selectedBackgroundColor={"#FFFFFF"}
                                    stylesForTab={{
                                        color: '#344054',
                                        fontSize: '1.6rem',
                                        fontStyle: 'normal',
                                        fontWeight: '500',
                                        lineHeight: '2.4rem',
                                        padding: "0.8rem 1.2rem",
                                        textTransform: 'unset',
                                        borderBottom: "1px solid #EAECF0"
                                    }}
                                    borderColor={"#1570EFs"}
                                    stylesForWrapper={{
                                        padding: "1.5rem 0",
                                        background: "#FFFFFF",
                                    }}
                                    list={!useCsv ? createLaunch.timeline : createLaunch.timeline.filter((e) => { return e.value !== 'Select Payment Plans' && e.value !== 'Select PriceList' })}
                                    value={createLaunch.timeline.find(f => f.isSelected).value}
                                    handleChange={(e, value) => {
                                        tabChanged(e, value)
                                        searchParams.set('submenu', value)
                                        setSearchParams(searchParams);
                                    }}
                                />
                                <TabPanel className={cssClasses.tabPanel} value={"Add Launch Title"} index={0}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <div style={{ maxWidth: "40rem" }}>
                                            <CustomInput helperText={launchTitleHelperText} label={'Launch Title'} mandatory={true} handleChange={launchTitleChanged} placeholder={'Launch Title'} value={launchTitle} />
                                        </div>
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Select Project"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectProject allProjects={(allProjects.filter((e) => { return e.show === true }))} projectGridColums={projectGridColums} setSearchProject={setSearchProject} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Select Sales"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectSalesCp allChildRows={allChildSales} deSelectAll={deSelectAll} selectAll={selectAll} allRows={(allChildSales?.filter((e) => { return e.show === true }))} allColums={salesGridColumns} setSearchSalesCp={setSearchSales} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Select Cp"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectSalesCp selectAll={selectAll} deSelectAll={deSelectAll} allChildRows={allChildCp} allRows={(allChildCp.filter((e) => { return e.show === true }))} allColums={cpGridColumns} setSearchSalesCp={setSearchCp} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Select Inventory"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectInventory allInventory={allInventory} allUnitsToMerge={allUnitsToMerge} setOpenAlert={setOpenAlert} showMerge={showMerge} setShowMerge={setShowMerge} unitsToMerge={unitsToMerge} setUnitsToMerge={setUnitsToMerge} showMergeBtn={false} allChildInventory={allChildInventory} mode={'edit'} setAllChildInventory={setAllChildInventory} totalFloorsSelected={totalFloorsSelected} totalUnitsSelected={totalUnitsSelected} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Select PriceList"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectSalesCp selectAll={selectAll} deSelectAll={deSelectAll} allChildRows={allChildPriceList} allRows={(allChildPriceList.filter((e) => { return e.show === true }))} allColums={PriceGridColumns} setSearchSalesCp={setSearchPriceList} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Select Payment Plans"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectSalesCp selectAll={selectAll} deSelectAll={deSelectAll} allChildRows={allChildPlans} allRows={(allChildPlans.filter((e) => { return e.show === true }))} allColums={planGridColumns} setSearchSalesCp={setSearchPlan} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Preview Inventory"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <SelectInventory allChildInventory={allChildInventory} mode={'preview'} setAllChildInventory={setAllChildInventory} totalFloorsSelected={totalFloorsSelected} unitsToMerge={unitsToMerge} totalUnitsSelected={totalUnitsSelected} />
                                    </Box>
                                </TabPanel>
                                <TabPanel className={cssClasses.tabPanel} value={"Preselect Config"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <PreselectConfig  launchData={launchData} setLaunchData={setLaunchData} eventTokens={eventTokens} setEventTokens={setEventTokens}/>
                                        </Box>
                                </TabPanel>
                               <TabPanel className={cssClasses.tabPanel} value={"Online Booking Config"} index={1}>
                                    <Box className={cssClasses.mainTabPanelWrapper}>
                                        <OnlineBookingConfig  launchData={launchData} setLaunchData={setLaunchData} eventTokens={eventTokens} setEventTokens={setEventTokens}/>
                                        </Box>
                                </TabPanel>
                              
                            </TabContext>
                        </Box>
                    </div>
                </div>
            </div>
            <div className={cssClasses.footer}>
                <div className={cssClasses.btnWrapper} style={{ marginBottom: "1.6rem" }}>
                    {createLaunch.timeline[0].isSelected !== true &&
                        <Button clicked={() => {
                            setCreateLaunch((pre) => {
                                let index = createLaunch.timeline.findIndex((e) => e.isSelected === true);
                                if (useCsv && index === 7) {
                                    pre.timeline[index].isSelected = false; pre.timeline[5].isSelected = true;
                                    searchParams.set('submenu', "Select Inventory")
                                    setSearchParams(searchParams)
                                    return { ...pre };
                                } else {
                                    pre.timeline[index].isSelected = false; pre.timeline[index - 1].isSelected = true;
                                    searchParams.set('submenu', createLaunch.timeline[index - 1].value)
                                    setSearchParams(searchParams)
                                    return { ...pre };
                                }
                            });
                            setSearchCp('');
                            setSearchSales('');
                            setSearchProject('')
                        }} btnName={'Back Step'} style={{ borderRadius: "0.4rem", backgroundColor: "#D0D5DD", color: "#FFFFFF", fontSize: "1.6rem" }} padding={"0.5rem 1rem"} iconPosition={"left"} />
                    }
                </div>
                <div className={cssClasses.btnWrapper} style={{ marginBottom: "1.6rem" }}>
                        < Button clicked={nextStep} btnName={'Save & Next Step'} style={{ borderRadius: "0.4rem", backgroundColor: "#1570EF", color: "#FFFFFF", fontSize: "1.6rem" }} padding={"0.5rem 1rem"} iconPosition={"left"} />
                    
                </div>
            </div>
            {openAlert &&
                <ConfirmationAlert confirm={(e) => { ModalResp(e) }} buttonTitle={'Cancel'} returnRespButton={'Continue'} close={() => setOpenAlert(false)} title={'Warning'} subTitle={'Unsaved Changes! Do you want to continue without saving'} open={openAlert} />
            }
        </div>
    )
}
